import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
const { useDocumentWidth } = Hooks;
const {getUrl} = Util;
import Banner from "@/assets/images/academy/banner.png"
import Bannerphone from "@/assets/images/academy/bannerphone.png"
import Download from "@/assets/images/academy/downmload.png"

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  const isMobile = (useDocumentWidth() ?? 0) <= 768;

  return (
    <div className={cx(styles.banner, className)} style={isMobile ? {} : { backgroundImage: `url(${Banner})` }}>
      <div className={cx(styles.content, className)}>
        <h1 className={cx(styles.title, className)}>Sigma Academy</h1>
        <h4 className={cx(styles.text, className)}>Welcome to Sigma Academy. Whether you've already got some cryptocurrency knowledge, or you're just curious as to what the hype is about crypto, Sigma Academy is here for you.</h4>
        <a href={getUrl("/academy/learn-crypto")}>
          <div className={cx(styles.btns, className)}>
            <h4>Start Learning</h4>
          </div>
        </a>
      </div>
    </div>
  );
};

export default observer(Main);
// export default Main;
